import {Column, Row, RowLR, Spinner, Text, TextInput, Select, CheckBox} from "react-vcomponents";
import {BaseComponent} from "react-vextensions";
import {ControlInput} from "../../../@Shared/ControlInput";
import {PhaseSelectionUI} from "../../../@Shared/PhaseSelectionUI.js";
import {EngineConfigPanels_SharedProps, ExtendEngineConfigPanelSharedProps} from "../ConfigPanel_Local.js";
import React from "react";
import {EffectPointer} from "../../../../Server/DB/@Shared/EffectPointer.js";
import {EffectPointerInput} from "../../../@Shared/EffectPointerInput.js";
import {SpinnerForPercent} from "../../../../Utils/ReactComponents/SpinnerForPercent.js";

const GetSharedProps = (props: EngineConfigPanels_SharedProps)=>ExtendEngineConfigPanelSharedProps(props, c=>c.background, (c, v)=>c.background = v);

const splitAt = 130;
export class Background_ConfigUI extends BaseComponent<{remote?: boolean} & EngineConfigPanels_SharedProps, {}> {
	render() {
		const {client, enabled} = this.props;
		const sharedProps = GetSharedProps(this.props);
		const {config, ChangeConfig} = sharedProps;

		return (
			<Column mt={15} style={{background: "hsla(0,0%,100%,.1)", borderRadius: 5, padding: 5}}>
				<Row style={{fontSize: 18}}>
					<CheckBox text="Background" enabled={enabled} value={config.enabled} onChange={val=>ChangeConfig(c=>c.enabled = val)}/>
				</Row>

				{config.enabled &&
				<>
					<RowLR mt={5} splitAt={splitAt}>
						<Text mr={10}>Increase volume:</Text>
						<ControlInput enabled={enabled} value={config.increaseVolume_triggerSet} onChange={val=>ChangeConfig(c=>c.increaseVolume_triggerSet = val)}/>
						{!client &&
						<>
							<Text ml={10}>Amount: </Text>
							<SpinnerForPercent enabled={enabled} value={config.increaseVolume_amount} onChange={val=>ChangeConfig(c=>c.increaseVolume_amount = val)}/>
						</>}
					</RowLR>
					<RowLR mt={5} splitAt={splitAt}>
						<Text mr={10}>Decrease volume:</Text>
						<ControlInput enabled={enabled} value={config.decreaseVolume_triggerSet} onChange={val=>ChangeConfig(c=>c.decreaseVolume_triggerSet = val)}/>
						{!client &&
						<>
							<Text ml={10}>Amount: </Text>
							<SpinnerForPercent enabled={enabled} value={config.decreaseVolume_amount} onChange={val=>ChangeConfig(c=>c.decreaseVolume_amount = val)}/>
						</>}
					</RowLR>
					{!client &&
					<RowLR mt={5} splitAt={splitAt}>
						<Text mr={10}>Effect: </Text>
						<EffectPointerInput enabled={enabled} value={config.effect ?? new EffectPointer()} onChange={val=>ChangeConfig(c=>c.effect = val)}/>
					</RowLR>}
					{!client &&
					<RowLR mt={5} splitAt={splitAt}>
						<Text mr={10}>Base-enabled, unless (any):</Text>
						<CheckBox text="Micro-snoozing" value={config.effectsBaseEnabledUnless_microSnoozeActive} onChange={val=>ChangeConfig(c=>c.effectsBaseEnabledUnless_microSnoozeActive = val)}/>
						<CheckBox ml={5} text="Media->play" value={config.effectsBaseEnabledUnless_mediaCompPlaying} onChange={val=>ChangeConfig(c=>c.effectsBaseEnabledUnless_mediaCompPlaying = val)}/>
						<Text ml={10}>In phase:</Text>
						<PhaseSelectionUI value={config.effectsBaseEnabledUnless_inPhases ?? []} onChange={val=>ChangeConfig(c=>c.effectsBaseEnabledUnless_inPhases = val)}/>
					</RowLR>}
					{!client &&
					<RowLR mt={5} splitAt={splitAt}>
						<Text mr={10}>Start volume: </Text>
						<SpinnerForPercent enabled={enabled} value={config.startVolume} onChange={val=>ChangeConfig(c=>c.startVolume = val)}/>
					</RowLR>}
				</>}
			</Column>
		);
	}
}